import { render, staticRenderFns } from "./SearchBuddy.vue?vue&type=template&id=dff8af5c&"
import script from "./SearchBuddy.vue?vue&type=script&lang=js&"
export * from "./SearchBuddy.vue?vue&type=script&lang=js&"
import style0 from "./SearchBuddy.vue?vue&type=style&index=0&id=dff8af5c&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports